import { Row, Col, Form, Container } from "react-bootstrap";
import {
  FormControl,
  TextField,
  Button,
  Typography,
  InputAdornment,
} from "@mui/material";
import { Link } from "react-router-dom";

import AccountCircle from "@mui/icons-material/AccountCircle";
import LockIcon from "@mui/icons-material/Lock";
import LoginIcon from "@mui/icons-material/Login";

import img2 from "../../images/logo2.png";
import layout from "../../config/layout";

const LoginForm = ({
  user,
  password,
  setUser,
  setPassword,
  handleSubmit,
  handleKeyDown,
  clearApiResponse,
}) => {
  return (
    <Form onKeyDown={handleKeyDown}>
      <Row
        className="align-items-center justify-content-between"
        style={{ marginBottom: "50px" }}
      >
        <Col md={3} sm={12} className="text-center text-md-start mb-3 mb-md-0">
          <img
            src={img2}
            alt="Logo"
            style={{ maxWidth: "180px", height: "auto" }}
          />
        </Col>

        <Col md={9} sm={12}>
          <Row className="align-items-center justify-content-md-end g-3">
            <Col xs={12} sm={4} md={4}>
              <FormControl fullWidth>
                <TextField
                  label="Twój email"
                  value={user}
                  onChange={(e) => {
                    setUser(e.target.value);
                    clearApiResponse();
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AccountCircle
                          fontSize="small"
                          sx={{ color: "text.secondary" }}
                        />
                      </InputAdornment>
                    ),
                  }}
                />
              </FormControl>
            </Col>

            <Col xs={12} sm={4} md={4}>
              <FormControl fullWidth>
                <TextField
                  label="Hasło"
                  type="password"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    clearApiResponse();
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LockIcon
                          fontSize="small"
                          sx={{ color: "text.secondary" }}
                        />
                      </InputAdornment>
                    ),
                  }}
                />
              </FormControl>
            </Col>

            <Col xs={12} sm="auto">
              <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={handleSubmit}
                startIcon={<LoginIcon />}
                sx={{
                  fontWeight: 600,
                  px: 3,
                  height: "40px",
                  borderRadius: "8px",
                  textTransform: "none",
                  backgroundColor: "#1a237e",
                  "&:hover": { backgroundColor: "#0d1b60" },
                }}
              >
                Zaloguj się
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row>
        <Col xs={12} sm="auto" className="ms-auto text-end">
          Jeśli nie pamiętasz hasła - <Link to="/pass-reset">Reset hasła</Link>
        </Col>
      </Row>
    </Form>
  );
};

export default LoginForm;
